import { render, staticRenderFns } from "./create-biller-product.vue?vue&type=template&id=3216f63e&scoped=true&"
import script from "./create-biller-product.vue?vue&type=script&lang=js&"
export * from "./create-biller-product.vue?vue&type=script&lang=js&"
import style0 from "./create-biller-product.vue?vue&type=style&index=0&id=3216f63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3216f63e",
  null
  
)

export default component.exports